import {DropDownList, DropDownListChangeEvent} from "@progress/kendo-react-dropdowns";
import styles from './GridPagerZone.module.scss'
import {VivoPortal} from "@utils/AppConstants";
import GridPagingSteps = VivoPortal.GridPagingOptions;
import {useEffect, useLayoutEffect, useState} from "react";
import GridDefaultPageSize = VivoPortal.GridPagingDefaultValue;
import FlintPager from "@components/controls/FlintPager";

export default function GridPagerZone(props: gridPagerZoneProps) {
    const pagingSteps = props.pagingSteps ?? GridPagingSteps;
    const [selectedPagingOption, setSelectedPagingOption] = useState<number>(props.defaultPageSize ?? GridDefaultPageSize);

    function onPageSelected(e: DropDownListChangeEvent) {
        setSelectedPagingOption(e.value);
        if (props.onPageSizeSelected)
            props.onPageSizeSelected(e.value);

    }
    return (
        <div className={styles.gridPagerZone}>
            <div className={`input-group ${styles.itemsPerPage}`}>
                <span className={"input-group-text"}>Rows per page</span>
                <DropDownList size={"medium"} className={"kendo-form-select border-start-0 font-size-medium"}
                              data={pagingSteps}
                              defaultValue={selectedPagingOption} onChange={onPageSelected}/>
            </div>
            <FlintPager pageSize={selectedPagingOption} totalItems={props.totalItems}
                        onPageChange={props.onPageChange}/>
        </div>

    );
}

export interface gridPagerZoneProps {
    pagingSteps?: number[],
    defaultPageSize?: number,
    totalItems: number,
    onPageSizeSelected?: (ps: number) => void;
    onPageChange?: (page: number) => void;
}